<section class="section about" id="about">
  <div class="container">
    <div class="section-box">
      <div class="about-title" data-aos="fade-up">
        <h3 class="section-title">
          <span class="n-section-title">01.</span>
          About Me
        </h3>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 mb-4 mb-md-0">
          <div class="about-description">
            <p data-aos="fade-up" data-aos-duration="1000">
              I'm an experienced developer with over {{ angularYears }} years of
              <span class="underline">Angular</span> and {{ wordpressYears }}+
              years of <span class="underline"> WordPress expertise</span>. I’ve
              worked on projects ranging from dynamic web applications to
              seamless eCommerce platforms, creating responsive and user-centric
              digital experiences. Whether it's building complex systems like
              different management platforms or crafting custom eCommerce
              solutions, I focus on delivering high-performance applications
              that drive results. Working with international clients has taught
              me the importance of clean code, high scalability, and
              cross-platform compatibility.I love contributing my knowledge to
              create new things that help solve problems. My capabilities also
              include implementing system improvements, optimizing sites,
              standardizing patterns, and suggesting and executing ideas that
              add value to the project.
            </p>

            <ul class="skills-list" data-aos="fade-up">
              <li
                class="skill-element"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <span class="underline">Angular </span>
              </li>
              <li
                class="skill-element"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <span class="underline">WordPress </span>
              </li>
              <li
                class="skill-element"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <span class="underline">HTML &amp; (S)CSS </span>
              </li>
              <li
                class="skill-element"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <span class="underline">Ionic </span>
              </li>
              <li
                class="skill-element"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <span class="underline">JavaScript (ES6+) </span>
              </li>

              <li
                class="skill-element"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <span class="underline">Bootstrap </span>
              </li>
              <li
                class="skill-element"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <span class="underline">CI / CD </span>
              </li>
            </ul>

            <div class="personal-details">
              <span class="underline"
                ><strong>Location:</strong> Islamabad, Pakistan</span
              >&nbsp;&nbsp;&nbsp;
              <span class="underline"
                ><strong>Languages:</strong> English, Urdu</span
              >
            </div>
          </div>
        </div>
        <div
          class="col-12 col-md-6 mt-4 mt-md-0 text-center"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <div class="about-img-container">
            <img
              class="rounded"
              width="400"
              height="300"
              src="assets/images/profile.png"
              alt="Muhammad Abubakar"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
